import React, { useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { ROUTE_KEYS, STORAGE_KEYS } from '../helpers/constants';
import { ENUM_KITCHEN_ROLE } from '@cokitchen/cokitchen-auth';

import { CoKitchenType, CokitchenTypeEnum } from '../helpers/types';
import homeStore from '../stores/homeStore';
import { getCokitchenType } from '../helpers/functions';

const ProtectedRoute = observer(function ProtectedRoute({
  component: Component,
  authenticated,
  allowAdmin,
  panelRole,
  ...rest
}: any) {
  const role = localStorage.getItem(STORAGE_KEYS.ROLE) as ENUM_KITCHEN_ROLE;
  const token: any = localStorage.getItem(STORAGE_KEYS.TOKEN);

  const cokitchenId = localStorage.getItem(STORAGE_KEYS.COKITCHEN) ?? '';

  const { getCokitchenById } = homeStore;

  const fetchActiveCokitchen = async () => {
    const cokitchenType = getCokitchenType();
    if (cokitchenType === CokitchenTypeEnum.POP || cokitchenType === CokitchenTypeEnum.DINE_IN) {
      return;
    }
    const cokitchen: CoKitchenType = await getCokitchenById(cokitchenId);
    localStorage.setItem(STORAGE_KEYS.COKITCHEN_TYPE, JSON.stringify(cokitchen.cokitchen_type));
  };

  useEffect(() => {
    fetchActiveCokitchen();
  }, []);

  return (
    <Route
      {...rest}
      render={(props: JSX.IntrinsicAttributes) =>
        token !== null &&
        token !== undefined &&
        (role === panelRole || (Array.isArray(panelRole) && panelRole.includes(role))) ? (
          <Route render={() => <Component {...props} />} />
        ) : (
          <Redirect to={ROUTE_KEYS.LOGIN} />
        )
      }
    />
  );
});
export default ProtectedRoute;
